export const getPhoneMask = (strValue: string, withDDD = true): string => {
  const { length } = String(strValue);
  const ddd = withDDD ? '(00) ' : '';
  const phoneMask = '0000-00009';
  const cellphoneMask = '0 0000-0000';
  const mask = length > 8 + (withDDD ? 2 : 0) ? cellphoneMask : phoneMask;

  return `${ddd}${mask}`;
};
